<template>
    <Layout class="container bg-reset">
        <!-- 左侧菜单 -->
        <Sider
            hide-trigger
            class="sider bg-reset"
            style="
                width: 180px;
                min-width: 180px;
                max-width: 180px;
                flex: 0 0 180px;
            "
        >
            <div class="sider-title">
                <div class="sider-title-text">楼栋</div>
                <div
                    v-if="isChoosePark && $can('add')"
                    class="sider-title-btn"
                    @click="addFloor"
                >
                    新增楼栋
                </div>
            </div>
            <div class="tree-container">
                <div
                    v-if="leftLoading"
                    style="
                        display: inline-block;
                        width: 100%;
                        height: 560px;
                        position: relative;
                    "
                >
                    <Spin fix size="large"></Spin>
                </div>
                <Tree
                    v-else
                    :data="parkList"
                    @on-select-change="selectItem"
                ></Tree>
            </div>
        </Sider>
        <!-- 右侧内容 -->
        <div
            v-if="rightLoading"
            style="
                display: inline-block;
                width: 100%;
                height: 100%;
                position: relative;
            "
        >
            <Spin fix size="large"></Spin>
        </div>
        <Layout v-else>
            <Content class="content bg-reset">
                <!-- 园区为空 -->
                <div class="content-empty content-empty-park" v-if="!hasPark">
                    <div class="content-empty-text">暂无园区</div>
                    <Button
                        v-if="$can('add')"
                        type="primary"
                        class="content-empty-btn"
                        @click="addPark"
                    >
                        马上添加
                    </Button>
                </div>
                <!-- 楼栋为空 -->
                <div
                    class="content-empty content-empty-floor"
                    v-else-if="!hasFloor"
                >
                    <div class="content-empty-text">请新增楼栋</div>
                </div>
                <!-- 不为空 -->
                <div v-else class="content-full">
                    <Tabs
                        class="router-view"
                        style="padding-left: 30px; height: 100%"
                        :animated="false"
                        v-model="houseTab"
                    >
                        <TabPane
                            label="有效房源"
                            style="height: 100%"
                            name="valid"
                        >
                            <div class="header">
                                <div class="header-left">
                                    <Icon
                                        custom=" iconfont iconfont-daloujianzhu"
                                        size="78"
                                        class="header-left-icon"
                                    ></Icon>
                                </div>
                                <div class="header-right">
                                    <div class="header-right-info">
                                        <div class="title-container">
                                            <span style="white-space: nowrap">
                                                <span class="title">{{
                                                    headerName
                                                }}</span>
                                                <span
                                                    class="text"
                                                    v-if="chooseLevel !== 1"
                                                >
                                                    共
                                                    <span
                                                        style="color: #2c8df0"
                                                        >{{
                                                            roomList.length
                                                        }}</span
                                                    >间， 租住
                                                    <span
                                                        style="color: #2c8df0"
                                                        >{{
                                                            roomFullList.length
                                                        }}</span
                                                    >
                                                    间， 预定
                                                    <span
                                                        style="color: #2c8df0"
                                                        >{{
                                                            roomBookList.length
                                                        }}</span
                                                    >
                                                    间， 空置
                                                    <span
                                                        style="color: #ff3739"
                                                        >{{
                                                            roomEmptyList.length
                                                        }}</span
                                                    >
                                                    间， 锁定
                                                    <span
                                                        style="color: #ff3739"
                                                        >{{
                                                            roomLockList.length
                                                        }}</span
                                                    >
                                                    间
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div style="display: flex">
                                        <Button
                                            v-if="$can('add') && isChooseFloor"
                                            type="primary"
                                            style="margin-right: 10px"
                                            @click="addRoom"
                                        >
                                            新增房间
                                        </Button>
                                        <Button
                                            v-if="
                                                $can('update') &&
                                                (isChooseFloor || isChooseLevel)
                                            "
                                            type="default"
                                            style="margin-right: 10px"
                                            @click="batchEditRoom"
                                        >
                                            批量修改房间
                                        </Button>
                                        <Button
                                            v-if="
                                                $can('delete') &&
                                                (isChooseFloor || isChooseLevel)
                                            "
                                            type="default"
                                            style="margin-right: 10px"
                                            @click="batchDeleteRoom"
                                        >
                                            批量删除房间
                                        </Button>
                                        <Button
                                            v-if="
                                                $can('update') && isChooseLevel
                                            "
                                            type="default"
                                            style="margin-right: 10px"
                                            @click="mergeRoom"
                                        >
                                            合并房间
                                        </Button>
                                        <Button
                                            v-if="
                                                $can('update') &&
                                                isChooseFloor &&
                                                chooseLevel !== 3
                                            "
                                            type="default"
                                            style="margin-right: 10px"
                                            @click="updateFloor"
                                        >
                                            修改楼栋
                                        </Button>
                                        <Button
                                            v-if="
                                                $can('delete') &&
                                                isChooseFloor &&
                                                chooseLevel !== 3
                                            "
                                            type="default"
                                            style="margin-right: 10px"
                                            @click="deleteFloor"
                                        >
                                            删除楼栋
                                        </Button>
                                        <div
                                            class="status-btn"
                                            v-if="chooseLevel !== 1"
                                            style="line-height: 34px"
                                        >
                                            <switch-btn
                                                @on-click="changeStatus"
                                                :arrIndex="arrIndex"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                :class="{
                                    body: true,
                                    eClass: chooseLevel == 1,
                                }"
                            >
                                <div
                                    v-if="chooseLevel == 1"
                                    class="echarts-class"
                                >
                                    <assets-park-echart
                                        v-if="
                                            chooseLevel == 1 && currentPark.id
                                        "
                                        :currentPark="currentPark"
                                    />
                                </div>
                                <div
                                    v-else
                                    class="body-item"
                                    id="roomContainer"
                                >
                                    <Spin fix size="large" v-if="fixLoading" />
                                    <!-- 房间卡片 -->
                                    <room
                                        v-else
                                        v-for="item in roomList"
                                        :key="item.id"
                                        :room="item"
                                        @menuItemClick="clickRoomMenuItem"
                                        class="room-class"
                                    />
                                </div>
                            </div>
                        </TabPane>
                        <TabPane
                            label="无效房源"
                            style="height: 100%"
                            name="invalid"
                        >
                            <div class="header">
                                <div class="header-left">
                                    <Icon
                                        custom=" iconfont iconfont-daloujianzhu"
                                        size="78"
                                        class="header-left-icon"
                                    ></Icon>
                                </div>
                                <div class="header-right">
                                    <div class="header-right-info">
                                        <div class="title-container">
                                            <span style="white-space: nowrap">
                                                <span class="title">
                                                    {{ headerName }}
                                                </span>
                                                <span
                                                    class="text"
                                                    v-if="chooseLevel !== 1"
                                                >
                                                    共
                                                    <span
                                                        style="color: #717171"
                                                        >{{
                                                            roomList.length
                                                        }}</span
                                                    >间无效房源
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="body" style="height: calc(100% - 50px)">
                                <div class="body-item" id="roomContainer">
                                    <Spin fix size="large" v-if="fixLoading" />
                                    <room
                                        v-else
                                        v-for="item in roomList"
                                        :key="item.id"
                                        :room="item"
                                        @menuItemClick="clickRoomMenuItem"
                                        class="room-class"
                                    />
                                </div>
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </Content>
        </Layout>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showCParkForm"
            :title="curId ? '编辑园区' : '新增园区'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <c-park-form v-if="modal.showCParkForm" :id="curId" />
        </smart-modal>

        <smart-modal
            v-model="modal.showFloorForm"
            :title="curId ? '编辑楼栋' : '新增楼栋'"
            :width="800"
            :height="500"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <floor-form
                v-if="modal.showFloorForm"
                :id="curId"
                :parkId="filter.parkId"
                :floorInfoList="floorInfoList"
                :form-mode="formMode"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showRoomForm"
            :title="actionTitle + '房间'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <room-form
                v-if="modal.showRoomForm"
                :id="curId"
                :parkId="this.filter.parkId"
                :floorId="this.filter.floorId"
                :floorName="currentFloor ? currentFloor.name : room.floorName"
                :floorNum="this.filter.floorNum"
                :room="room"
                :floorLevel="floorLevel"
                :form-mode="formMode"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showRoomBatchEditForm"
            title="批量修改房间"
            :width="1080"
            :height="680"
            :maskClosable="false"
        >
            <room-batch-edit-form
                v-if="modal.showRoomBatchEditForm"
                :parkId="this.filter.parkId"
                :floorId="this.filter.floorId"
                :floorNum="this.filter.floorNum"
                :floorName="currentFloor ? currentFloor.name : room.floorName"
                @search="search"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showRoomBatchDeleteForm"
            title="批量删除房间"
            :width="800"
            :height="600"
            :maskClosable="false"
        >
            <room-batch-delete-form
                v-if="modal.showRoomBatchDeleteForm"
                :parkId="this.filter.parkId"
                :floorId="this.filter.floorId"
                :floorNum="this.filter.floorNum"
                :floorName="currentFloor ? currentFloor.name : room.floorName"
                @search="search"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showRoomMergeForm"
            title="合并房间"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <room-merge-form
                v-if="modal.showRoomMergeForm"
                :parkId="this.filter.parkId"
                :floorId="this.filter.floorId"
                :floorName="currentFloor ? currentFloor.name : room.floorName"
                :floorNum="this.filter.floorNum"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showRoomSplitForm"
            title="拆分房间"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <room-split-form
                v-if="modal.showRoomSplitForm"
                :id="curId"
                :parkId="this.filter.parkId"
                :floorId="this.filter.floorId"
                :floorName="currentFloor ? currentFloor.name : room.floorName"
                :floorNum="this.filter.floorNum"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showBookForm"
            :title="curId ? '预定信息' : '录入预定信息'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <book-form v-if="modal.showBookForm" :id="curId" :room="room" />
        </smart-modal>

        <smart-modal
            v-model="modal.showMeter"
            title="水电抄表"
            :width="960"
            :height="650"
            :maskClosable="false"
            :async="false"
            :buttons="[]"
            @close-by-confirm="fetch"
        >
            <Meter v-if="modal.showMeter" :room="room" />
        </smart-modal>

        <smart-modal
            v-model="modal.showMeterRecord"
            title="抄表记录"
            :width="960"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <MeterRecord v-if="modal.showMeterRecord" :room="room" />
        </smart-modal>

        <smart-modal
            v-model="modal.showRentalList"
            title="出租记录"
            :width="960"
            :height="600"
            :maskClosable="false"
        >
            <rental-list v-if="modal.showRentalList" :room="room" />
        </smart-modal>
        <!-- 弹出框-提示 -->
        <alter :text="modalMsg" v-model="alterShow" @closeAlter="closeAlter" />
        <!-- 提示信息——房间删除 -->
        <confirm
            :text="modalMsg"
            v-model="confirmShowRoom"
            :id="curId"
            @closeModal="closeModalRoom"
            @confirmModal="confirmModalRoom"
        />
        <!-- 提示信息——房间锁定 -->
        <confirm
            :text="modalMsg"
            v-model="confirmShowLock"
            :id="curId"
            @closeModal="closeModalLock"
            @confirmModal="confirmModalLock"
        />
        <!-- 提示信息——房间解锁 -->
        <confirm
            :text="modalMsg"
            v-model="confirmShowUnlock"
            :id="curId"
            @closeModal="closeModalUnlock"
            @confirmModal="confirmModalUnlock"
        />
        <!-- 提示信息——楼栋删除 -->
        <confirm
            :text="modalMsg"
            v-model="confirmShowFloor"
            :id="curId"
            @closeModal="closeModalFloor"
            @confirmModal="confirmModalFloor"
        />
        <!-- 提示信息——房间预定 -->
        <confirm
            :text="modalMsg"
            v-model="confirmShowBook"
            :id="curId"
            @closeModal="closeModalBook"
            @confirmModal="confirmModalBook"
            btnConfirm="退还定金"
            btnCancel="没收定金"
        />
    </Layout>
</template>
<script>
import mChartLine from '_v/common/m-chart-line'
import mList from '_v/common/m-list'
import { dayjs, deepCopy } from '_u/helper'
import { mapCache } from '@/plugins/vux-data-cache'
import CParkForm from '../../admin/sys/configuration/c-park-form'
import FloorForm from './floor-form'
import RoomForm from './room-form'
import RoomBatchEditForm from './room-batch-edit-form'
import RoomBatchDeleteForm from './room-batch-delete-form'
import RoomMergeForm from './room-merge-form'
import RoomSplitForm from './room-split-form'
import BookForm from './book-form'
import RentalList from './rental-list'
import Room from '_v/components/room'
import Alter from '_v/components/alter'
import Confirm from '_v/components/confirm'
import SwitchBtn from '_v/components/switch-btn'
import AssetsParkEchart from './assets-park-echart'
import Meter from './meter'
import MeterRecord from './meter-record'
import {
    assetsTreeList,
    assetsHouseList,
    assetsHouseDelete,
    assetsHouseLocking,
    assetsFloorView,
    assetsFloorDelete,
    assetsBookStop,
} from '@/api/assets'
import { getContractByHouse } from '@/api/contract'

export default {
    name: 'AssetsPark',
    mixins: [mList, mChartLine],
    components: {
        CParkForm,
        FloorForm,
        RoomForm,
        RoomMergeForm,
        RoomSplitForm,
        BookForm,
        RentalList,
        Alter,
        Confirm,
        Room,
        SwitchBtn,
        Meter,
        MeterRecord,
        AssetsParkEchart,
        RoomBatchEditForm,
        RoomBatchDeleteForm,
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            fixLoading: false,
            leftLoading: false,
            rightLoading: false,
            curId: '',
            parkList: [],
            roomList: [],
            modal: {
                showCParkForm: false,
                showFloorForm: false,
                showRoomForm: false,
                showRoomMergeForm: false,
                showRoomSplitForm: false,
                showBookForm: false,
                showRentalList: false,
                showMeter: false,
                showMeterRecord: false,
                showRoomBatchEditForm: false,
                showRoomBatchDeleteForm: false,
            },
            parkActiveIndex: '',
            headerName: '',
            floorName: '',
            room: {},
            currentPark: null,
            currentFloor: null,
            floorLevel: 0, // 编辑/新增房间的楼栋的层数
            floorInfoList: [], // 编辑楼栋时，楼栋信息
            dict: {
                parkType: this.$dict.NULL,
                houseStatus: this.$dict.NULL,
            },
            modalMsg: '',
            alterShow: false,
            confirmShowFloor: false,
            confirmShowBook: false,
            confirmShowRoom: false,
            confirmShowLock: false,
            confirmShowUnlock: false,
            chooseLevel: 1, // 左侧选择层级
        }
    },
    watch: {
        houseTab() {
            this.getHouse()
        },
    },

    computed: {
        ...mapCache({
            filter: 'assetsParkIndex',
            houseTab: 'houseTab', // 房源有效无效tab
        }),
        arrIndex() {
            let list = []
            if (this.filter) {
                const stateList = this.filter.houseStatus.split(',')
                stateList.forEach((v) => {
                    list.push(v)
                })
            }
            return list
        },
        // 有园区
        hasPark() {
            return this.parkList.length > 0
        },
        // 有楼栋
        hasFloor() {
            const park = this.currentPark
            return park && park.children.length > 0
        },
        // 选择园区
        isChoosePark() {
            return this.parkList.length && this.filter.parkId !== ''
        },
        isChooseFloor() {
            return this.filter.floorId !== ''
        },
        isChooseLevel() {
            return this.filter.floorNum !== ''
        },
        // 房间空置
        roomEmptyList() {
            return this.roomList.filter((v) => v.houseStatus === '1')
        },
        // 房间预定
        roomBookList() {
            return this.roomList.filter((v) => v.houseStatus === '2')
        },
        // 房间租住
        roomFullList() {
            return this.roomList.filter((v) => v.houseStatus === '3')
        },
        // 房间锁定
        roomLockList() {
            return this.roomList.filter((v) => v.houseStatus === '5')
        },
    },
    created() {
        this.fetch()
    },

    methods: {
        fetch() {
            this.loading = true
            this.leftLoading = true
            this.rightLoading = true

            Promise.all([
                assetsTreeList({ pageNo: 1, pageSize: 999, level: 3 }),
                this.$dict.get(['house_status', 'park_type', 'action_type']),
            ])
                .then((args) => {
                    var [res, group] = args

                    Object.assign(this.dict, group)

                    const list = res.data.list
                    const parkList = []

                    list.sort((a, b) => a.level - b.level)
                    list.forEach((v) => {
                        v.title = v.name
                        if (v.level === 1) {
                            v.children = []
                            parkList.push(v)
                        } else if (v.level === 2) {
                            const park = parkList.find((m) => m.id === v.pid)
                            if (park) {
                                v.children = []
                                v.title = v.title
                                park.children.push(v)
                            }
                        } else if (v.level === 3) {
                            parkList.forEach((park) => {
                                const floor = park.children.find(
                                    (n) => n.id === v.pid
                                )
                                if (floor) {
                                    v.children = []
                                    floor.children.push(v)
                                }
                            })
                        }
                    })
                    if (this.filter.parkId === '' && parkList.length > 0) {
                        this.filter.parkId = parkList[0].id

                        if (
                            this.filter.floorId === '' &&
                            parkList[0].children.length > 0
                        ) {
                            this.filter.floorId = parkList[0].children[0].id
                        }
                    }

                    this.parkList = parkList
                    this.getTreeNode()
                })
                .finally(() => {
                    this.loading = false
                    this.leftLoading = false
                    this.rightLoading = false
                })
        },
        // 获取房间列表
        getHouse() {
            this.fixLoading = true
            this.roomList = []
            const filter = deepCopy(this.filter)
            if (this.houseTab === 'invalid') {
                filter.houseStatus = '4'
            }

            assetsHouseList(filter)
                .then((res) => {
                    const list = res.data.page.list
                    list.forEach((v) => {
                        v.houseStatusText = this.dict.houseStatus.get(
                            v.houseStatus
                        ).text
                        v.isEmpty = v.houseStatus === '1'
                        v.isBook = v.houseStatus === '2'
                        v.isRent = v.houseStatus === '3'
                        v.isInvalid = v.houseStatus === '4'
                        v.isLocked = v.houseStatus === '5'
                        // 不同状态，room 显示的租金不同
                        if (v.isEmpty || this.houseTab === 'invalid') {
                            v.showPrice = v.rent
                        } else if (v.isBook) {
                            v.showPrice = v.reserveRent
                        } else if (v.isRent) {
                            v.showPrice = v.contractRent
                        }
                        v.showPrice /= 100

                        // 空置多少天
                        if (v.isEmpty) {
                            const nowDate = dayjs()
                            if (v.changeDate) {
                                v.days = nowDate.diff(
                                    dayjs(v.changeDate),
                                    'day'
                                )
                            } else if (v.updateTime) {
                                v.days = nowDate.diff(
                                    dayjs(v.updateTime),
                                    'day'
                                )
                            }
                        }
                    })
                    // 有效房间按名称排序，无效房间按后台的顺序——作废时间倒序
                    if (this.houseTab === 'valid') {
                        list.sort((a, b) => a.houseNum - b.houseNum)
                    }

                    this.roomList = list
                })
                .finally(() => {
                    this.fixLoading = false
                })
        },
        // 获取默认节点
        getTreeNode() {
            let { parkId, floorId, floorNum } = this.filter
            let node = null
            let park = null
            let floor = null
            let level = null
            if (parkId) {
                park = this.parkList.find((v) => parkId === v.id)
                node = park
            }
            if (floorId && park) {
                floor = park.children.find((v) => v.id === floorId)
                this.$set(park, 'expand', true)
                node = floor
            }
            if (floorNum && floor) {
                level = floor.children.find((v) => v.id === floorNum)
                this.$set(floor, 'expand', true)
                node = level
            }
            if (node) {
                this.$set(node, 'selected', true)
                this.selectItem([], node)
            }
        },
        // TreeItem更改
        selectItem(arr, currentItem) {
            if (currentItem.level === 1) {
                this.currentPark = currentItem
                this.filter.parkId = this.currentPark.id

                this.filter.floorId = ''
                this.currentFloor = null

                this.filter.floorNum = ''
                this.roomList = []
                this.chooseLevel = 1
                if (this.houseTab === 'invalid') {
                    this.getHouse()
                }
                // this.getHouse();
            } else if (currentItem.level === 2) {
                this.currentPark = this.parkList.find(
                    (v) => v.id === currentItem.pid
                )
                this.filter.parkId = this.currentPark.id

                this.filter.floorId = currentItem.id
                this.currentFloor = currentItem

                this.filter.floorNum = ''
                this.chooseLevel = 2
                this.getHouse()
            } else if (currentItem.level === 3) {
                this.parkList.forEach((v) => {
                    const floor = v.children.find(
                        (p) => p.id === currentItem.pid
                    )
                    if (floor) {
                        this.currentFloor = floor
                        this.filter.floorId = this.currentFloor.id
                    }
                })

                this.currentPark = this.parkList.find(
                    (v) => v.id === this.currentFloor.pid
                )
                this.filter.parkId = this.currentPark.id

                this.filter.floorNum = currentItem.id
                this.chooseLevel = 3
                this.getHouse()
            }
            this.getHeaderName()
        },
        // 获取标题
        getHeaderName() {
            let str = ''
            str += this.currentPark ? this.currentPark.name : ''
            str += this.currentFloor ? this.currentFloor.name : ''
            str += this.filter.floorNum ? this.filter.floorNum + '层' : ''
            str += '(' + this.dict.parkType.val(this.currentPark.code) + ')'
            this.headerName = str
        },
        // 更改楼层
        changeLevel(name) {
            this.filter.floorNum = name.split('-')[2] - 0 + 1
            this.getHouse()
        },
        // 更改房间筛选状态
        changeStatus(value) {
            const list = this.filter.houseStatus.split(',')
            const findIndex = list.findIndex((v) => v === value)
            if (findIndex === -1) {
                list.push(value)
            } else {
                if (list.length > 1) {
                    list.splice(findIndex, 1)
                }
            }
            this.filter.houseStatus = list.join(',')
            this.getHouse()
        },
        // 点击房间菜单
        clickRoomMenuItem({ name, room }) {
            console.log(`name: ${name},room: ${room}`)
            this[name](room)
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
        // 添加园区
        addPark() {
            this.curId = ''
            this.modal.showCParkForm = true
        },
        // 添加楼栋
        addFloor() {
            this.curId = ''
            this.formMode = this.FORM_MODE.add
            this.modal.showFloorForm = true
        },
        // 修改楼栋
        updateFloor() {
            if (!this.currentFloor) return

            this.curId = this.currentFloor.id
            this.formMode = this.FORM_MODE.update
            this.modal.showFloorForm = true
            this.floorInfoList = []
            this.currentFloor.children.forEach((v, index) => {
                const roomList = this.roomList.filter(
                    (p) =>
                        p.houseNum.slice(0, p.houseNum.length - 2) === v.id + ''
                )
                let flag = true
                roomList.forEach((p) => {
                    if (p.houseStatus !== '1') {
                        flag = false
                    }
                })
                this.floorInfoList.push({ level: v.id, flag })
            })
        },
        // 删除楼栋
        deleteFloor() {
            if (!this.currentFloor) {
                return
            }
            let canDelete = true
            this.roomList.forEach((v) => {
                if (v.houseStatus !== '1') {
                    canDelete = false
                }
            })
            if (canDelete) {
                this.modalMsg = '删除楼栋后无法撤回需重新添加，是否确定？'
                this.confirmShowFloor = true
                this.curId = this.currentFloor.id
            } else {
                this.modalMsg = '该楼栋下有房间租住中或曾被出租，无法删除'
                this.alterShow = true
            }
        },
        closeModalFloor() {
            this.confirmShowFloor = false
        },
        confirmModalFloor(id) {
            assetsFloorDelete(id)
                .then(() => {
                    this.$Message.success(this.$t('tips.delete.success'))
                    this.confirmShowFloor = false
                    console.log(this.currentPark)
                    if (this.currentPark.children.length) {
                        this.currentFloor = this.currentPark.children[0]
                        this.filter.floorId = this.currentFloor.id
                        this.chooseLevel = 2
                    } else {
                        this.currentFloor = null
                        this.filter.floorId = ''
                        this.chooseLevel = 1
                    }

                    this.filter.floorNum = ''
                    this.getHouse()
                    this.getHeaderName()
                })
                .finally(() => this.fetch())
        },
        // 添加房间
        addRoom() {
            if (!this.currentFloor) {
                return
            }
            assetsFloorView(this.currentFloor.id)
                .then((res) => {
                    this.floorLevel = res.data.entity.levelNum
                })
                .finally(() => {
                    this.curId = ''
                    this.formMode = this.FORM_MODE.add
                    this.modal.showRoomForm = true
                })
        },
        // 查看房间
        viewRoom(room) {
            const park = this.parkList.find((v) => v.id === room.parkId)
            const floor = park.children.find((v) => v.id === room.floorId)
            assetsFloorView(floor.id)
                .then((res) => {
                    this.floorLevel = res.data.entity.levelNum
                })
                .finally(() => {
                    this.curId = room.id
                    this.formMode = this.FORM_MODE.view
                    this.room = room
                    this.modal.showRoomForm = true
                })
        },
        // 修改房间
        updateRoom(room) {
            const park = this.parkList.find((v) => v.id === room.parkId)
            const floor = park.children.find((v) => v.id === room.floorId)
            assetsFloorView(floor.id)
                .then((res) => {
                    this.floorLevel = res.data.entity.levelNum
                })
                .finally(() => {
                    this.curId = room.id
                    this.formMode = this.FORM_MODE.update
                    this.room = room
                    this.modal.showRoomForm = true
                })
        },
        // 删除房间
        deleteRoom(room) {
            if (room.houseStatus === '1' && !room.contractStatus) {
                this.modalMsg = '删除房间后无法撤回需重新添加，是否确定？'
                this.confirmShowRoom = true
                this.curId = room.id
            } else {
                this.modalMsg = '该楼栋下有房间租住中或曾被出租，无法删除'
                this.alterShow = true
            }
        },
        closeModalRoom() {
            this.confirmShowRoom = false
        },
        confirmModalRoom(id) {
            assetsHouseDelete(id)
                .then(() => {
                    this.$Message.success(this.$t('tips.delete.success'))
                    this.confirmShowRoom = false
                })
                .finally(() => this.fetch())
        },
        // 拆分房间
        splitRoom(room) {
            //已上架到找房或出房的房源不允许拆分
            if (room.publishStatus == '1' || room.zwzhaoPublishStatus == '1'){
              this.modalMsg = '请先下架房源再拆分'
              this.alterShow = true
              return
            }
            // 不为空置，不能拆分
            if (room.houseStatus !== '1') {
                this.modalMsg = '预定或租住中房间无法拆分'
                this.alterShow = true
            } else {
                this.curId = room.id
                this.modal.showRoomSplitForm = true
            }
        },
        // 锁定房间
        lockRoom(room) {
            this.modalMsg = '锁定房间后无法预定和录入合同，是否确定？'
            this.confirmShowLock = true
            this.curId = room.id
        },
        closeModalLock() {
            this.confirmShowLock = false
        },
        confirmModalLock(id) {
            assetsHouseLocking(id)
                .then(() => {
                    this.$Message.success(this.$t('tips.update.success'))
                    this.confirmShowLock = false
                })
                .finally(() => this.fetch())
        },
        // 解锁房间
        unlockRoom(room) {
            this.modalMsg = '解锁房间后能够再次预定和录入合同，是否确定？'
            this.confirmShowUnlock = true
            this.curId = room.id
        },
        closeModalUnlock() {
            this.confirmShowUnlock = false
        },
        confirmModalUnlock(id) {
            assetsHouseLocking(id)
                .then(() => {
                    this.$Message.success(this.$t('tips.update.success'))
                    this.confirmShowUnlock = false
                })
                .finally(() => this.fetch())
        },
        // 批量修改房间
        batchEditRoom() {
            this.modal.showRoomBatchEditForm = true
        },
        // 批量删除房间
        batchDeleteRoom() {
            this.modal.showRoomBatchDeleteForm = true
        },
        // 合并房间
        mergeRoom() {
            this.modal.showRoomMergeForm = true
        },
        // 录入预定信息
        inputBook(room) {
            this.curId = ''
            this.room = room
            this.modal.showBookForm = true
        },
        // 查看预定信息
        viewBook(room) {
            this.curId = room.id
            this.room = room
            this.modal.showBookForm = true
        },
        // 终止预定
        stopBook(room) {
            this.curId = room.id
            this.modalMsg = '退还定金后待付账单新增一笔，需手动付款'
            this.confirmShowBook = true
        },
        // 终止预定-退定金
        closeModalBook(id) {
            assetsBookStop({ id, isReturn: 0 })
                .then(() => {
                    this.$Message.success(this.$t('tips.delete.success'))
                    this.confirmShowBook = false
                })
                .finally(() => this.fetch())
        },
        // 终止预定-没收定金
        confirmModalBook(id) {
            assetsBookStop({ id, isReturn: 1 })
                .then(() => {
                    this.$Message.success(this.$t('tips.delete.success'))
                    this.confirmShowBook = false
                })
                .finally(() => this.fetch())
        },
        // 录入合同
        inputContract(room) {
            this.$router.push({
                name: 'contractCreate',
                query: {
                    houseId: room.id,
                    from: 'assetsParkIndex',
                },
            })
        },
        // 查看合同
        viewContract(room) {
            getContractByHouse(room.id).then((res) => {
                this.$router.push({
                    name: 'contractViewIndex',
                    query: {
                        contractId: res.data.contractCus.contractId,
                        type: '5',
                    },
                })
            })
        },
        // 出租记录
        rentRecording(room) {
            console.log(room)
            this.room = room
            this.modal.showRentalList = true
        },

        // 水电抄表
        meterReading(room) {
            console.log(room)
            this.room = room
            this.modal.showMeter = true
        },

        // 抄表记录
        meterRecording(room) {
            console.log(room)
            this.room = room
            this.modal.showMeterRecord = true
        },

        // 关闭 alter
        closeAlter() {
            this.alterShow = false
        },
    },
}
</script>
<style lang="less" scoped>
.container {
    height: 100%;
    padding: 20px;

    // 侧边菜单
    .sider {
        border: 1px solid #eeeeee;

        // 菜单头部
        &-title {
            height: 47px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #eeeeee;
            margin-bottom: 8px;
            &-text {
                font-size: 16px;
                font-weight: 500;
                text-align: left;
                color: rgb(51, 51, 51);
                position: relative;
                margin-left: 30px;
                flex-grow: 1;
            }
            &-text::before {
                position: absolute;
                top: 50%;
                left: -18px;
                width: 6px;
                height: 18px;
                border-radius: 2px;
                background-color: rgb(44, 141, 240);
                transform: translateY(-50%);
                content: '';
            }
            &-btn {
                width: 90px;
                text-align: center;
                color: @primary-color;
                cursor: pointer;
            }
        }
        // 菜单
        .tree-container {
            width: 100% !important;
            height: ~'calc(100% - 55px)';
            overflow-x: hidden;
            overflow-y: auto;
        }
    }

    // 内容区
    .content {
        height: 100%;
        min-width: 800px;
        // 为空
        &-empty {
            height: 100%;
            width: 100%;
            position: relative;
            text-align: center;
            &-text {
                width: 100%;
                height: 21px;
                font-size: 16px;
                color: rgb(170, 170, 170);
                position: absolute;
                top: 70%;
                left: 50%;
                transform: translateX(-50%);
            }
            &-btn {
                width: 93px;
                position: absolute;
                top: 80%;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        &-empty-park {
            background: url('~@/assets/img/placeholder/no-yuanqu.png') no-repeat;
            background-size: 316px 249px;
            background-position: center;
        }
        &-empty-floor {
            background: url('~@/assets/img/placeholder/no-yuanqu.png') no-repeat;
            background-size: 316px 249px;
            background-position: center;
        }
        // 不为空
        &-full {
            height: 100%;
            width: 100%;
            .header {
                padding: 11px 0px;
                display: flex;
                &-left {
                    &-icon {
                        background: #f2f2f2;
                        color: #dddddd;
                        border-radius: 8px;
                    }
                }
                &-right {
                    flex-grow: 1;
                    margin-left: 12px;
                    &-info {
                        line-height: 40px;
                        display: flex;
                        .title-container {
                            flex-grow: 1;
                            overflow: hidden;
                            .title {
                                font-size: 20px;
                                color: #333333;
                            }
                            .text {
                                font-size: 12px;
                                color: #aaaaaa;
                                margin-left: 16px;
                                white-space: nowrap;
                            }
                        }
                        .status-btn {
                            width: 230px;
                        }
                    }
                }
            }
            .body {
                height: ~'calc(100% - 150px)';
                overflow-y: scroll;

                &-item {
                    height: 100%;
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;

                    .room-class {
                        margin-right: 25px;
                        margin-top: 25px;
                    }
                }
            }
            .echarts-class {
                margin: 60px 20px 0px 50px;
            }
            .eClass {
                overflow-y: hidden;
            }
        }
    }
}

// 背景颜色
.bg-reset {
    background-color: #fff;
}
</style>

<style lang="less">
.ivu-tabs-content {
    height: 100%;
}
</style>
